import { useMap, useMapEvents } from "react-leaflet";
import { fetchAddressFromCoords } from "./fetchAddressFromCoords";
import { MapMarker } from "./MapMarker";
import { FaMapLocationDot } from "react-icons/fa6";

export const MapController = ({ data, setData, className }) => {
    const map = useMap();
  
    const handleUpdateLocation = async (lat, lng) => {
      setData((prev) => ({ ...prev, latitude: lat, longitude: lng }));
      map.flyTo([lat, lng], 17);
  
      const address = await fetchAddressFromCoords(lat, lng);
      if (address) {
        setData((prev) => ({ ...prev, address: address }));
      }
    };
  
    useMapEvents({
      click(e) {
        handleUpdateLocation(e.latlng.lat, e.latlng.lng);
      },
    });
  
    const handleLocate = () => {
      if (!navigator.geolocation) return alert("Browser tidak mendukung Geolocation");
      map.locate({ setView: false, maxZoom: 16 });
      map.once("locationfound", async (e) => {
        handleUpdateLocation(e.latlng.lat, e.latlng.lng);
      });
      map.once("locationerror", () => alert("Gagal mendapatkan lokasi. Pastikan GPS aktif."));
    };
  
    return (
      <>
        <MapMarker position={{ lat: data.latitude, lng: data.longitude }} />
        <button
          type="button"
          onClick={handleLocate}
          className={
            `absolute z-[5000] bottom-5 right-6 ${className} bg-slate-800 text-cyan-400 p-3 rounded-full shadow-2xl border border-slate-600 hover:bg-cyan-600 hover:text-white transition-all active:scale-90 flex items-center justify-center`
          }
          title="Deteksi Lokasi Saya"
        >
          <FaMapLocationDot size={20} />
        </button>
      </>
    );
  };